export default "__VITE_ASSET__sPB0TQtm__"